import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import {
  Criteria,
  QuotaPayload,
  RangeSet,
} from '../../../../../shared/interfaces/quota.interface';
import { UNITS } from '../../../../../shared/constants/currency-units';
import { QUALIFICATION_CODES } from '../../../../../shared/constants/qualification-code';
import { ChildrenLabelMapper } from 'purespectrum-lib';
import { DEFAULT } from '../../../../..//shared/constants/defaults';

@Component({
  selector: 'ps-ui-quota-review-modal',
  templateUrl: './quota-review-modal.component.html',
  styleUrls: ['./quota-review-modal.component.css'],
})
export class QuotaReviewModalComponent implements OnInit {
  public quotas: Quota[] = [];
  public title: string = '';
  public modalType: ModalType = 'impossible-quotas';
  constructor(
    private _modalRef: ModalRef<QuotaReviewModalComponent, string>,
    @Inject(ModalData) private _modalData: ModalData
  ) {}

  public ngOnInit(): void {
    this.quotas = this._modalData.quotas;
    this.title = this._modalData.title;
    this.modalType = this._modalData.type;
  }

  public getQualificationNameString(quota: Quota): string {
    if (quota.quota_title) {
      return quota.quota_title;
    }

    return quota.criteria.length === 1
      ? (quota.criteria[0].qualification_name as string)
      : quota.group_key || DEFAULT.NESTED_GROUP_KEY;
  }

  public getConditionNameString(item: Criteria): string {
    if (
      Number(item.qualification_code) === QUALIFICATION_CODES.CHILD_AGE_GENDER
    ) {
      return new ChildrenLabelMapper(
        (item.condition_codes || []).map(Number)
      ).label();
    }

    if (item.range_sets?.length && item.range_sets?.length > 0) {
      return item.range_sets
        .reduce(
          (conditions: string[], rangeSet: RangeSet) => [
            ...conditions,
            this._getRangeConditionString(rangeSet),
          ],
          []
        )
        .join(',');
    }

    if (item.group_name) {
      return item.group_name;
    }

    if (item.condition_names?.length && item.condition_names.length > 0) {
      return item.condition_names.join(',');
    }

    return 'Unknown condition';
  }

  private _getRangeConditionString(rangeSet: RangeSet): string {
    const unit = UNITS[`${rangeSet.units}`];
    return `${rangeSet.from} ${unit} - ${rangeSet.to} ${unit}`;
  }

  public close() {
    this._modalRef.close();
  }
}

type ModalType = 'difficult-quotas' | 'impossible-quotas';

type ModalData = {
  type: ModalType;
  quotas: Quota[];
  title: string;
};

type Quota = Pick<QuotaPayload, 'buyer_quota_id' | 'group_key'> & {
  criteria: Record<string, unknown>[];
  quota_type: string;
  quota_title: string;
};
